/* eslint-disable no-param-reassign,no-underscore-dangle */

xplenty.directive('formSubmitButton', [
  '$translate',
  '$rootScope',
  function ($translate, $rootScope) {
    return {
      restrict: 'E',

      replace: true,

      template:
        '<button class="btn" data-action="submit" ng-class="{ \'loading\': form.$submiting }" ng-disabled="form.$submiting||form.$invalid || isDisabled"><span ng-if="form.$new">{{createText}}</span><span ng-if="!form.$new">{{updateText}}</span></button>',

      scope: {
        form: '=ngModel',
        updateText: '@',
        isDisabled: '=?',
      },

      link(scope, element, attrs) {
        if (!scope.form) {
          $rootScope.$log.error('Error (form-submit-button): Provide form controller');
        }

        const createText = attrs.createText || 'form-submit-button.create-text';
        const updateText = attrs.updateText || 'form-submit-button.update-text';

        $translate([createText, updateText]).then(function (t) {
          scope.createText = t[createText];
          scope.updateText = t[updateText];
        });

        element.on('click', function () {
          if (!scope.form.$submiting && scope.form.$valid && scope.form._submit) {
            scope.form._submit();
          }
        });
      },
    };
  },
]);
